export class WizardModel {
   name: string = 'Test Wizard';
   address: string = 'Some place';
   age: number = 23;
   food: string = 'pizza';
}